import { useTheme } from '@mui/material/styles';
import { useMobile } from 'src/hooks/useMobile';
import { GradientBorder } from '../gradients/GradientBorder';
import { ImageOptimized } from '../image/ImageOptimized';

export type PartnerCardProps = {
  logoUrl: string;
  name: string;
};
export function PartnerCard(props: PartnerCardProps) {
  const theme = useTheme();
  const { logoUrl, name } = props;
  const isMobile = useMobile();
  return (
    <GradientBorder
      borderRadius="10px"
      gradientBackground={`linear-gradient(${theme.palette.background.elevationSolid[16]}, 
        ${theme.palette.background.elevationSolid[16]}), 
        ${theme.palette.primary.vertical}`}
      sx={{
        position: 'relative',
        width: isMobile ? 'calc(33.33% - 13px)' : '172px',
        height: '136px',
      }}
    >
      <ImageOptimized
        src={logoUrl}
        alt={name}
        objectFit="contain"
        width={178}
        height={132}
      />
    </GradientBorder>
  );
}
